import { createAsyncThunk, createSlice, } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { login, logout } from 'src/api/users';
import { getItem, getTokenData, setItem, } from 'src/utils/localStorage';
import constants from 'src/constants';

export interface AuthState {
  id: string;
  token: string;
  status: 'idle' | 'loading' | 'ready';
}

const initialState: AuthState = {
  id: '',
  token: '',
  status: 'idle',
};

const redirectToSSOPage = async () => {

  const tokenData = getTokenData();
  if (tokenData !== null) {

    const responseType = encodeURIComponent(
      'id_token token',
    );
    const scope = encodeURIComponent('openid');
    const nonce = encodeURIComponent('anything');

    const state = encodeURIComponent('anything');
    const clientId = encodeURIComponent(
      `${process.env.REACT_APP_SSO_CLIENT_ID}`,
    );
    const redirectUri = encodeURIComponent(
      `${constants.SSO_URL_LOGIN_CALLBACK}`,
    );
    let tenantCode = '';
    if (window.location.hostname) {
      tenantCode = window.location.hostname.split('.')[0];
    }

    const ssoLink = `${constants.SSO_URL_LOGIN}?response_type=${responseType}&scope=${scope}&nonce=${nonce}&state=${state}&client_id=${clientId}&redirect_uri=${redirectUri}&tenant_code=${tenantCode}`;
    window.location.href = ssoLink;
  }
};

export const userLogin = createAsyncThunk(
  'auth/login',
  async (params: {
    ssotoken: string;
    otpToken: string;
    appVersion: 1;
  }) => {
    const { data } = await login(params);
    setItem('ework_sso_id', data.id);
    return {
      token: data.token,
      id: data.id,
    };
  },
);

export const userLogout = createAsyncThunk(
  'auth/logout',
  async () => {
    const userId = encodeURIComponent(
      getItem('ework_sso_id') ?? '',
    );
    const firebaseToken = encodeURIComponent(
      getItem('ework_firebase_token') ?? '',
    );
    const tokenData = encodeURIComponent(
      getTokenData() ?? '',
    );
    const tokenDataObject = JSON.parse(getTokenData());
    const sessionId = tokenDataObject.sessionId;
    let tenantCode = "";
    if (window.location.hostname) {
      tenantCode = window.location.hostname.split(".")[0];
    }
    const ework_sso_refresh_token = encodeURIComponent(
      getItem('ework_sso_refresh_token') ?? '',
    );
    const eworkTokenData = encodeURIComponent(
      getItem('eworkTokenData') ?? '',
    );
    const _logout = () => {
      // removeToken();
      // localStorage.removeItem('ework_sso_id');
      // localStorage.removeItem('ework_sso_sessionId');
      // localStorage.removeItem('tokenData');
      // localStorage.removeItem('ework_sso_refresh_token');
      // localStorage.removeItem('eworkTokenData');
      // clearAllLS();
      const clientId = encodeURIComponent(
        constants.SSO_CLIENT_ID,
      );
      const redirectUri = encodeURIComponent(
        constants.SSO_URL_LOGOUT_CALLBACK,
      );
      const url = `${constants.SSO_URL_LOGOUT}?client_id=${clientId}&redirect_uri=${redirectUri}&tenant_code=${tenantCode}&userId=null&sessionId=${sessionId}`;
      if (sessionId) {
        window.location.href = url;
      } else {
        redirectToSSOPage();
      }
    };
    if (firebaseToken) {
      logout({
        token: firebaseToken,
      }).then(
        res => {
          _logout();
        },
        error => {
          _logout();
        },
      );
    } else {
      _logout();
    }
  },
);

export const authenSlice = createSlice({
  name: 'authen',
  initialState,
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: builder => {
    builder.addCase(
      userLogin.fulfilled,
      (state, action: any) => {
        const { token, id } = action.payload;
        state.token = token;
        state.id = id;
        state.status = 'ready';
      },
    );
  },
});

export const selectAuthen = (state: RootState) =>
  state.authen;

export default authenSlice.reducer;